import React from 'react';
import DashboardLayout from '@/components/layouts/DashboardLayout';
import PortalProtectedRoute from '@/routes/PortalProtectedRoute';
import type { PortalRouteDef } from '@/config/portalRoutes.config';

export const authPageLayout = (page: React.ReactNode) => (
  <div className="min-h-screen bg-gray-50">{page}</div>
);

export const protectedAppPageLayout = (
  route: PortalRouteDef,
  page: React.ReactNode,
) => (
  <PortalProtectedRoute route={route}>
    <DashboardLayout>{page}</DashboardLayout>
  </PortalProtectedRoute>
);
